// extracted by mini-css-extract-plugin
module.exports = {"container":"_10cjV1FGWwGSj_aw6-oM3_","buttons":"_2w7HH7gtQSsZxfNhfpb-3B","square":"_3QsyC1y9UDQc7crxLGECH3"};